<app-card-consulta [titulo]="titulo">
  <div
    class="card-msg d-flex flex-column bg-white text-dark text-center print-c"
  >
    <p>
      A vistoria cautelar, ora apresentada, é realizada por vistoriador
      habilitado da empresa contratante deste sistema licenciado pela UNION
      SOLUTIONS, sendo certo que o mesmo possui competência técnica para
      verificar avarias externas e alterações estruturais do veículo em análise,
      sem qualquer ajuste de peças ou manuseio do veículo. Não se atribui à
      presente vistoria cautelar a natureza de substituto de "Perícia Oficial
      Criminal" e\ou de qualquer laudo emitido por instituição oficial.
    </p>

    <p>
      As informações prestadas e atestadas na presente vistoria cautelar são
      válidas apenas para o momento de realização da vistoria. Neste sentido, a
      licenciada do sistema e a UNION SOLUTIONS não se responsabilizam por
      qualquer alteração eventualmente realizada no veículo, após a emissão
      desta vistoria cautelar.
    </p>

    <p>
      A UNION SOLUTIONS é responsável apenas pela transmissão das informações
      colhidas na sua base de dados, uma vez que estas são fornecidas por bancos
      de dados públicos e privados, não possuindo a UNION SOLUTIONS qualquer
      ingerência, condições e capacidade técnica para inserção, alteração e\ou
      exclusão de tais informações, sejam elas negativas ou positivas sobre o
      veículo. Portanto, a UNION SOLUTIONS é mera replicadora das informações
      constantes dos bancos de dados públicos e privados, não havendo qualquer
      responsabilidade quanto à inclusão, alteração e\ou exclusão de dados sobre
      os veículos consultados.
    </p>

    <p>
      Na hipótese de a presente vistoria cautelar ser utilizada para fins de
      contrato de financiamento e\ou de seguro, cumprese informar que as
      instituições financeiras e companhias de seguro adotam métodos e critérios
      próprios para a aceitação - ou não - de veículos, não se destinando a
      presente vistoria cautelar para aceite ou recusa por parte das referidas
      instituições.
    </p>
  </div>
</app-card-consulta>
